import { z as zod } from 'zod'

import { DefaultSchemas } from './defaultSchemas'

export const Report19DataSchemas = zod.object({
    salesCentre: zod.string(),
    salesCentreUser: zod.string().nullable(),
    ident: zod.string().nullable(),
    transactionDate: zod.string().nullable(),
    giftCardSalesSum: zod.number().nullable(),
    serviceFees: zod.number().nullable(),
    greetingCardFees: zod.number().nullable(),
    customGiftCardFees: zod.number().nullable(),
    seasonalGiftCardFees: zod.number().nullable(),
    courierFees: zod.string().nullable(),
    administrationFees: zod.number().nullable(),
    busTicketsSum: zod.number().nullable(),
    carparksSum: zod.number().nullable(),
    kiddyCruisersSum: zod.number().nullable(),
    carValetSum: zod.number().nullable(),
    parkingNMSum: zod.number().nullable(),
    handsFreeSum: zod.number().nullable(),
    deliveryServiceSum: zod.number().nullable(),
    miscellanousSum: zod.number().nullable(),
    carWashSum: zod.number().nullable(),
    productSum: zod.number().nullable(),
    tenderCashSum: zod.number().nullable(),
    tenderEftposSum: zod.number().nullable(),
    tenderVisaSum: zod.number().nullable(),
    tenderMcardSum: zod.number().nullable(),
    tenderAmexSum: zod.number().nullable(),
    tenderDinersSum: zod.number().nullable(),
    tenderGiftCardSum: zod.number().nullable(),
    tenderDirectCreditSum: zod.number().nullable(),
    tenderAllSum: zod.number().nullable(),
    orderColumn: zod.number().nullable(),
})

export const Report19CSVDataSchemas = zod.object({
    salesCentre: zod.string(),
    salesCentreUser: zod.string().nullable(),
    ident: zod.string().nullable(),
    transactionDate: zod.string().nullable(),
    giftCardSalesSum: zod.number().nullable(),
    serviceFees: zod.number().nullable(),
    greetingCardFees: zod.number().nullable(),
    customGiftCardFees: zod.number().nullable(),
    seasonalGiftCardFees: zod.number().nullable(),
    courierFees: zod.string().nullable(),
    administrationFees: zod.number().nullable(),
    busTicketsSum: zod.number().nullable(),
    carparksSum: zod.number().nullable(),
    kiddyCruisersSum: zod.number().nullable(),
    carValetSum: zod.number().nullable(),
    parkingNMSum: zod.number().nullable(),
    handsFreeSum: zod.number().nullable(),
    deliveryServiceSum: zod.number().nullable(),
    miscellanousSum: zod.number().nullable(),
    carWashSum: zod.number().nullable(),
    productSum: zod.number().nullable(),
    tenderCashSum: zod.number().nullable(),
    tenderEftposSum: zod.number().nullable(),
    tenderVisaSum: zod.number().nullable(),
    tenderMcardSum: zod.number().nullable(),
    tenderAmexSum: zod.number().nullable(),
    tenderDinersSum: zod.number().nullable(),
    tenderGiftCardSum: zod.number().nullable(),
    tenderDirectCreditSum: zod.number().nullable(),
    tenderAllSum: zod.number().nullable(),
    orderColumn: zod.number().nullable(),
})

export const Report19CreateFormSchemas = zod.object({
    startDate: zod.string().min(1, { message: 'Start date is Required.' }),
    endDate: zod.string().min(1, { message: 'End date is Required.' }),
    test: zod.number(),
    fromTraderId: zod.number().nullable().optional(),
    reportTypeId: zod.number(),
})

export const Report19APISchemas = DefaultSchemas.merge(
    zod.object({
        data: Report19DataSchemas.array()
    })
)

export type Report19CreateFormTypes = zod.infer<typeof Report19CreateFormSchemas>;
export type Report19DataTypes = zod.infer<typeof Report19DataSchemas>;
export type Report19CSVDataTypes = zod.infer<typeof Report19CSVDataSchemas>;    
export type Report19APITypes = zod.infer<typeof Report19APISchemas>;